import { useContext } from 'react';
import { AuthContext } from '../auth/context/AuthContext';
import { ADMIN_ROLES } from '../utilities/constants';

export function useIsAdminContextSafe(): boolean {
  const authContext = useContext(AuthContext);
  return authContext?.user?.role
    ? ADMIN_ROLES.includes(authContext?.user?.role)
    : false;
}
